export const ProposalActionTypes = {
  SET_PROPOSALS_WITH_TENANTS: 'SET_PROPOSALS_WITH_TENANTS',
  SET_SELECTED_PROPOSAL: 'SET_SELECTED_PROPOSAL',
  SET_VIEW_PROPOSAL: 'SET_VIEW_PROPOSAL',
}
